module.exports = __webpack_public_path__ + "static/media/text.07ceec8b.png";